// ---------------------------------------------- modules import
import { ThunkAction } from "redux-thunk";

import Actions from "./actions";
import { IPost, PostAction, PostActionType } from "./common";
import { AppState } from "../rootReducer";
import PermissionHelper from "../helpers/permissionHelper";
import { IPinnedPost } from "../pinnedPost/common";
import { IThunkExtraArgument } from "../../index";

// ---------------------------------------------- thunk actions
export const thunkAddPost = (
  post: IPost,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, PostAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { id, ...data } = post;

  dispatch(Actions.addBegin());

  firebase
    .firestore()
    .collection(collectionPath)
    .add(data)
    .then(() => dispatch(Actions.addSuccess()))
    .catch(error => dispatch(Actions.addError(error.message)));
};

export const thunkPinPost = (
  pinnedPost: IPinnedPost
): ThunkAction<void, AppState, IThunkExtraArgument, PostAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const collectionPath = PermissionHelper.getCollection(pinnedPost.indexOrigin);
  const { id, ...data } = pinnedPost;

  dispatch(Actions.pinBegin());

  firebase
    .firestore()
    .collection("pinnedPosts")
    .doc(id)
    .set(data)
    .then(() => {
      firebase
        .firestore()
        .collection(collectionPath)
        .doc(id)
        .delete()
        .then(() => dispatch(Actions.pinSuccess()))
        .catch(error => dispatch(Actions.pinError(error.message)));
    })
    .catch(error => dispatch(Actions.pinError(error.message)));
};

export const thunkUpdatePost = (
  post: IPost,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, PostAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();
  const { id, ...data } = post;

  dispatch(Actions.updateBegin());

  firebase
    .firestore()
    .collection(collectionPath)
    .doc(id)
    .update(data)
    .then(() => dispatch(Actions.updateSuccess()))
    .catch(error => dispatch(Actions.updateError(error.message)));
};

export const thunkDeletePost = (
  id: string,
  collectionPath: string
): ThunkAction<void, AppState, IThunkExtraArgument, PostAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  const firebase = getFirebase();

  dispatch(Actions.deleteBegin());

  firebase
    .firestore()
    .collection(collectionPath)
    .doc(id)
    .delete()
    .then(() => dispatch(Actions.deleteSuccess()))
    .catch(error => dispatch(Actions.deleteError(error.message)));
};

export const thunkEditorError = (
  action: PostAction
): ThunkAction<void, AppState, IThunkExtraArgument, PostAction> => (
  dispatch,
  getAppState,
  { getFirebase }
) => {
  switch (action.type) {
    case PostActionType.ADD_POST_ERROR: {
      dispatch(Actions.addError(action.payload.error));
      break;
    }
    case PostActionType.UPDATE_POST_ERROR: {
      dispatch(Actions.updateError(action.payload.error));
      break;
    }
    default: {
    }
  }
};
